define( function() {
	"use strict";

	return [];
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/arr.js
 ** module id = 102
 ** module chunks = 0
 **/